import { render, staticRenderFns } from "./UserPayments.vue?vue&type=template&id=421662fc&scoped=true"
import script from "./UserPayments.vue?vue&type=script&lang=js"
export * from "./UserPayments.vue?vue&type=script&lang=js"
import style0 from "./UserPayments.vue?vue&type=style&index=0&id=421662fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421662fc",
  null
  
)

export default component.exports